var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3682 29.2951C23.0598 29.2951 29.2951 23.0598 29.2951 15.3682C29.2951 7.67667 23.0598 1.44141 15.3682 1.44141C7.67667 1.44141 1.44141 7.67667 1.44141 15.3682C1.44141 23.0598 7.67667 29.2951 15.3682 29.2951Z",
    stroke: "white",
    strokeWidth: 0.960472,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2902 21.1311L11.5273 15.3683L17.2902 9.60547",
    stroke: "white",
    strokeWidth: 0.960472,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackButton);
export default __webpack_public_path__ + "static/media/backButton.4aff35f4f284373faf82adbddeb85c55.svg";
export { ForwardRef as ReactComponent };